module.exports = __webpack_public_path__ + "static/media/59.40ab407d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/59.jpg
// module id = 427
// module chunks = 0